/** Component IDs for slide template layers (matches backend component-registry).
 * Phase 10m: "media" = layout rule placeholder. Defines media area; synthesized into layoutRules.mediaMain. */
export const SLIDE_TEMPLATE_COMPONENT_IDS = [
  'background',
  'header',
  'agenda',
  'text',
  'image',
  'sponsors',
  'lowerThird',
  'backgroundVideo',
  'media',
  'html',
  'livekitTrackRoomCam',
  'livekitTrackRoomCamGrid',
  'livekitTrackRemoteSpeaker',
  'livekitTrackRemoteSpeakerGrid',
  'liveTranslation',
  'infoOverlay',
] as const;
